import { FIELD_TYPE_INFO } from "./const";

export const getDataTypeIcon = (dataType: string): string => {
  return FIELD_TYPE_INFO[dataType]?.icon ?? "text";
};

export const getDataTypeLabel = (dataType: string): string => {
  return FIELD_TYPE_INFO[dataType]?.label ?? "Campo";
};
